import React, { useEffect, useMemo, useRef, useState } from "react";
import useDateTimePicker from "./useDateTimePicker.js";
import useFlatpickr from "./useFlatpickr.js";

const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

const FlatpickrInput = ({
  className,
  name,
  value,
  placeholder,
  readOnly,
  onBlur,
  onChange = () => {},
  pickerOptions = {},
  disabled = false,
  pickerOverlay = false,
  ...rest
}) => {
  const ref = useRef(null);
  const isMounted = useRef(false);
  const id = useMemo(() => `datetimepicker-${Math.round(Math.random() * 10000000)}`, []);

  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  useFlatpickr(ref, onChange, setInputValue, { format: DEFAULT_DATE_FORMAT, ...pickerOptions }, pickerOverlay);

  return(
    <input
      id={id}
      ref={ref}
      type="text"
      className={className}
      name={name}
      value={inputValue}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      onBlur={onBlur}
      onChange={(e) => setInputValue(e.target.value)}
      {...rest}
    />
  )
};

export default FlatpickrInput;
